import React from "react";

export default function ProductAndSupplier() {
  return (
    <div className="aspect-[6/3] overflow-hidden rounded-lg">
      <iframe
        src="https://www.youtube.com/embed/siaq4GW-h7o"
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
      ></iframe>
    </div>
  );
}
